import requests from "@/utils/requests_self";
class Service {

  // 获取权益信息
  static getBenefitInfo = async (params = {}) => {
    return await requests.post('/customer/benefit/v1/list', JSON.stringify(params));
  }

  // 获取权益领取情况
  static getBenefitCheckInfo = async (params = {}) => {
    return await requests.post('/customer/benefit/v1/check', JSON.stringify(params));
  }

  // 领取权益
  static getBenefit = async (params = {}) => {
    return await requests.post('/customer/benefit/v1/claim', JSON.stringify(params));
  }

  // 获取藏品信息
  static getCollectionInfo = async (params = {}) => {
    return await requests.post('/customer/purchase/v2/getCollectionDetail', JSON.stringify(params));
  }

  // 藏品转化积分/宝石
  static convertCollection = async (params = {}) => {
    return await requests.post('/customer/activity/v2/convert', JSON.stringify(params));
  }
}
export default Service